import { Link } from "react-router-dom";
import FeedbackForm from "@/pages/about/components/FeedbackForm";
import { categories } from "@/mocks/categories";

const scopeItems = [
  { icon: "ri-gamepad-line", title: "游戏直播录像", desc: "MOBA、FPS、即时战略与沙盒生存等热门游戏的完整对局与操作集锦。" },
  { icon: "ri-emotion-happy-line", title: "娱乐内容剪辑", desc: "脱口秀、户外纪实、搞笑连麦与音乐现场的精华片段与名场面。" },
  { icon: "ri-music-2-line", title: "才艺表演精选", desc: "唱歌、舞蹈、乐器与绘画等方向的表演实录与创作过程记录。" },
];

const terms = [
  "本站所有视频与主播信息均为演示用途的示例数据，不代表真实播出内容。",
  "站内播放器为前端演示版本，用于展示基础播放控制，不提供真实流媒体播放能力。",
  "收藏功能仅将数据保存在你的本地浏览器中，清除浏览器数据后收藏记录会一并清空。",
  "站内内容仅供学习与浏览参考，如涉及版权问题，欢迎通过下方邮箱与我们沟通。",
];

export default function AboutPage() {
  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
      <nav className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-400">
          首页
        </Link>
        <i className="ri-arrow-right-s-line" />
        <span className="text-foreground-200">关于我们</span>
      </nav>

      <header className="mt-6 overflow-hidden rounded-lg border border-background-800 bg-background-900">
        <div className="relative">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20navy%20abstract%20streaming%20studio%20panorama%20with%20warm%20orange%20light%20streaks%2C%20floating%20holographic%20screens%20and%20soft%20particles%2C%20cinematic%20moody%20atmosphere%2C%20high%20contrast%20digital%20illustration&width=1600&height=600&seq=zbabout01-2026&orientation=landscape"
            alt="主播视频内容站"
            title="主播视频 内容站"
            className="h-52 w-full object-cover object-top md:h-72"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/80 to-background-950/40" />
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10">
            <span className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-3 py-1 text-xs font-semibold text-primary-300">
              <i className="ri-live-line" /> 关于主播视频
            </span>
            <h1 className="mt-4 max-w-2xl font-heading text-2xl font-extrabold leading-snug text-foreground-50 md:text-4xl">
              聚合主播直播录像与精彩集锦的内容站
            </h1>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-300 md:text-base">
              我们整理分散在各处的高光片段，让回看主播精彩内容变得简单高效。
            </p>
          </div>
        </div>
      </header>

      <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2 flex flex-col gap-6">
          <section className="rounded-lg border border-background-800 bg-background-900 p-5 md:p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-50">网站定位</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-300">
              主播视频是一个专注主播直播录像与精彩集锦聚合的内容平台。我们面向喜爱追看主播回放、
              剪辑短视频与精华集锦的视频爱好者，把游戏、娱乐、才艺等不同方向的内容按分类整理，
              并配合人气、时长、发布时间等维度筛选，帮助你快速找到想看的内容。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-300">
              无论你是想复看某位主播的经典操作，还是想发现值得关注的新声主播，都可以通过分类浏览、
              关键词搜索与热门推荐来发现感兴趣的内容。
            </p>
          </section>

          <section className="rounded-lg border border-background-800 bg-background-900 p-5 md:p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-50">内容范围与更新频率</h2>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {scopeItems.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-800 bg-background-950 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-100">{item.title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-400">{item.desc}</p>
                </div>
              ))}
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-300">
              站内内容保持每日更新，新视频会优先出现在首页「最新视频」栏目；
              热门推荐栏目则根据播放量与点赞数动态调整。你可以通过以下分类入口直接进入对应内容方向：
            </p>
            <div className="mt-4 flex flex-wrap gap-2.5">
              {categories.map((c) => (
                <Link
                  key={c.key}
                  to={`/category/${c.key}`}
                  className="flex items-center gap-1.5 rounded-full border border-background-700 px-4 py-2 text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-300"
                >
                  <i className={`${c.icon} text-primary-500`} />
                  {c.name}视频
                </Link>
              ))}
            </div>
          </section>

          <section className="rounded-lg border border-background-800 bg-background-900 p-5 md:p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-50">使用须知</h2>
            <ul className="mt-4 flex flex-col gap-3">
              {terms.map((t) => (
                <li key={t} className="flex gap-2.5 text-sm leading-relaxed text-foreground-300">
                  <i className="ri-checkbox-blank-circle-line mt-1 shrink-0 text-xs text-primary-500" />
                  {t}
                </li>
              ))}
            </ul>
          </section>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-lg border border-background-800 bg-background-900 p-5 md:p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-50">联系方式</h2>
            <p className="mt-2 text-sm text-foreground-400">如有内容建议、投稿或合作意向，可通过以下方式联系我们。</p>
            <div className="mt-4 flex flex-col gap-3 text-sm">
              <a
                href="mailto:hello@zhubo-video.example"
                className="flex items-center gap-3 rounded-md border border-background-800 bg-background-950 p-3 transition-colors hover:border-primary-500/60"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                  <i className="ri-mail-line" />
                </span>
                <span>
                  <span className="block text-xs text-foreground-500">邮箱</span>
                  <span className="text-foreground-200">hello@zhubo-video.example</span>
                </span>
              </a>
              <div className="flex items-center gap-3 rounded-md border border-background-800 bg-background-950 p-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-500/15 text-secondary-300">
                  <i className="ri-time-line" />
                </span>
                <span>
                  <span className="block text-xs text-foreground-500">反馈处理时间</span>
                  <span className="text-foreground-200">工作日 10:00 - 19:00</span>
                </span>
              </div>
            </div>
          </div>

          <FeedbackForm />
        </aside>
      </div>
    </div>
  );
}